import React from 'react';
import UnassignedTransactionsView from './unassignedTransactions/UnassignedTransactionsView';
import useUnassignedTransactions from './unassignedTransactions/useUnassignedTransactions';

export default function UnassignedTransactions() {
    const state = useUnassignedTransactions();
    return <UnassignedTransactionsView {...state} />;
}
